import React, { Fragment } from 'react'
import { Card, Heading } from '@myxplor/ui'
import { FormInput, FormPassword, FormSubmit, FormWrapper } from '@myxplor/forms'

import './authorisation.css'

const validate = ({ user, password }) => !!user && !!password

const AuthWithPasswordView = ({ authorisation, sendAuthorisation }) => {
  const { loading, errors = {} } = authorisation

  return (
    <Card title="Sign in" className="authorisation--wrapper">
      <Heading>Sign in to Xplor</Heading>

      <FormWrapper
        defaultValues={{ user: '', password: '' }}
        onSubmit={sendAuthorisation}
        validate={validate}
        render={({ onChange, values, valid }) => (
          <Fragment>
            <fieldset>
              <FormInput
                label="Email or username"
                name="user"
                value={values.user}
                required
                onChange={onChange}
                errors={errors.user}
                loading={loading}
                autoFocus
                htmlInput={{
                  autoComplete: 'current-email',
                }}
              />

              <FormPassword
                name="password"
                label="Password"
                required
                value={values.password}
                onChange={onChange}
                errors={errors.password}
                loading={loading}
                htmlInput={{
                  autoComplete: 'current-password',
                }}
              />
            </fieldset>

            <FormSubmit
              loadingTitle="Signing you in"
              errors={errors.summary || errors.detail}
              loading={loading}
              disabled={!valid}>
              Sign in
            </FormSubmit>
          </Fragment>
        )}
      />
    </Card>
  )
}

export default AuthWithPasswordView



// WEBPACK FOOTER //
// ./src/authorisation/with-password/view.jsx